import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  ENQUIRE_BULK_DIAGS_REQUEST: '',
  ENQUIRE_BULK_DIAGS_SUCCESS: '',
  ENQUIRE_BULK_DIAGS_FAILURE: '',

  ENQUIRE_BULK_CPTS_REQUEST: '',
  ENQUIRE_BULK_CPTS_SUCCESS: '',
  ENQUIRE_BULK_CPTS_FAILURE: '',

  SEARCH_MEMBERS_REQUEST: '',
  SEARCH_MEMBERS_SUCCESS: '',
  SEARCH_MEMBERS_FAILURE: '',

  GET_CM_WORK_LIST_REQUEST: '',
  GET_CM_WORK_LIST_SUCCESS: '',
  GET_CM_WORK_LIST_FAILURE: '',

  GET_MEMBER_REQUEST: '',
  GET_MEMBER_SUCCESS: '',
  GET_MEMBER_FAILURE: '',

  GET_MEMBER_REQUEST_REQUEST: '',
  GET_MEMBER_REQUEST_SUCCESS: '',
  GET_MEMBER_REQUEST_FAILURE: '',

  GET_TASK_OWNERS_REQUEST: '',
  GET_TASK_OWNERS_SUCCESS: '',
  GET_TASK_OWNERS_FAILURE: '',

  GET_PROVIDER_REQUEST: '',
  GET_PROVIDER_SUCCESS: '',
  GET_PROVIDER_FAILURE: '',

  REQUEST_MEMBER_REQUEST: '',
  REQUEST_MEMBER_SUCCESS: '',
  REQUEST_MEMBER_FAILURE: '',

  EMAIL_UPDATED_MEMBER_INFO_REQUEST: '',
  EMAIL_UPDATED_MEMBER_INFO_SUCCESS: '',
  EMAIL_UPDATED_MEMBER_INFO_FAILURE: '',

  GET_MEMBER_CONDITION_CODES_REQUEST: '',
  GET_MEMBER_CONDITION_CODES_SUCCESS: '',
  GET_MEMBER_CONDITION_CODES_FAILURE: '',


};

types = setStoreTypeValues(types, 'eligibility');

export default types;
